
import { asyncThunkCreator, createSlice } from '@reduxjs/toolkit';
import { TYPE_ADMIN, TYPE_OWNER } from '../../../../enums/Enum';
import AuthService from '../../../../services/auth/AuthService';
import EventBus from '../../../eventBus/EventBus';
import { ADMIN_SESSION_REMOVE_SUCCESS, AUTHENTICATION_LOGIN_SUCCESS, AUTHENTICATION_LOGOUT_SUCCESS, PROFILE_IMAGE_SUCCESS, PROFILE_SUCCESS } from '../../../eventBus/authEvents/authEvents';
import authService from '../../../../services/auth/AuthService';



export const authSlice = createSlice({
    name: "auth",
    initialState: {
        isAuthorized: false,
        account: null,
        users: [],
        userCount: [],
        adminFilterOptions: {
            page: 1,
            limit: 10,
        },
    },
    reducers: {
        login: (state) => {
            state.isAuthorized = true;
        },
        logout: (state) => {
            state.isAuthorized = false;
        },
        setAccount: (state, action) => {
            state.account = action.payload
        },
        updateAdminUsers: (state, action) => {
            state.users = action.payload
        },
        updateAdminUsersCount: (state, action) => {
            state.userCount = action.payload
        },
        updateFilterOptions: (state, action) => {
            state.adminFilterOptions = action.payload
        },
    }
})


export const changeFilterOptionsAsync = ({...params}) => dispatch => {
    dispatch(authSlice.actions.updateFilterOptions({...params}))
}



export const selectIsAuthorized = state => state.auth.isAuthorized;
export const selectAccount = state => state.auth.account;
export const selectIsOwner = state => state.auth.account?.type === TYPE_OWNER
export const selectIsAdmin = state => state.auth.account?.type === TYPE_ADMIN

export const selectUsers = state => state.auth.users
export const selectUserCount = state => state.auth.userCount
export const selectUserFilterOptions = state => state.auth.adminFilterOptions


export const initializeAsync = () => dispatch => {
    return new Promise((resolve, reject) => {
        AuthService.getMe()
            .then((response) => {
                dispatch(authSlice.actions.setAccount(response.data))
                dispatch(authSlice.actions.login())
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error);
                
                // reject(error)
                dispatch(authSlice.actions.setAccount([]))
            })

    })
}

export const loginAsync = ({email, password}) => dispatch => {

    return new Promise((resolve, reject) => {
        AuthService.login({email, password})
            .then((response) => {
                EventBus.dispatch(AUTHENTICATION_LOGIN_SUCCESS)
                dispatch(authSlice.actions.login())
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const logoutAsync = () => dispatch => {
    return new Promise((resolve, reject) => {
        AuthService.logout()
            .then((response) => {
                EventBus.dispatch(AUTHENTICATION_LOGOUT_SUCCESS)
                resolve(response.data)
            })
            .catch(error => {
                console.log(error);
                // reject(error)
            })
            .finally(() => {
                dispatch(authSlice.actions.logout())
            })
    })
}

export const registerAsync = ({email, name, surname, phone, country, description, password, confirmPassword}) => {
    return new Promise((resolve, reject) => {
        AuthService.register({email, name, surname, phone, country, description, password, confirmPassword})
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                console.log(error);
                reject(error)
            })
    })
}

export const profileAsync = ({name, surname, phone, country, description}) => {
    return new Promise((resolve, reject) => {
        AuthService.profile({name, surname, phone, country, description})
            .then((response) => {
                EventBus.dispatch(PROFILE_SUCCESS)
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const profileImageAsync = (file) => {
    return new Promise((resolve, reject) => {
        AuthService.profileImage(file)
            .then((response) => {
                EventBus.dispatch(PROFILE_IMAGE_SUCCESS)
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const changePasswordAsync = ({oldPassword, newPassword}) => {
    return new Promise((resolve, reject) => {
        AuthService.changePassword({oldPassword, newPassword})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const resetPasswordAsync = ({email, new_password}) => {
    return new Promise((resolve, reject) => {
        AuthService.resetPassword({email, new_password})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const forgotPasswordAsync = ({email}) => {
    return new Promise((resolve, reject) => {
        AuthService.forgotPassword({email})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}



// admin

export const getAdminUsersAsync = ({page, limit, ...filters}) => dispatch => {
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}

    return new Promise((resolve, reject) => {
        authService.getAdminUsers(params)
            .then((response) => {
                dispatch(authSlice.actions.updateAdminUsers(response?.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const getAdminUsersCountAsync = (params) => dispatch => {
    let { limit, page, ...filters} = params

    return new Promise((resolve, reject) => {
        authService.getAdminUsersCount(filters)
            .then((response) => {
                dispatch(authSlice.actions.updateAdminUsersCount(response.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const getAdminUserSessionAsync = ({id}) => {
    return new Promise((resolve, reject) => {
        authService.getAdminUserSession({id})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const removeAdminUserSessionAsync = ({account_id, token}) => {
    return new Promise((resolve, reject) => {
        authService.removeAdminUserSession({account_id, token})
            .then((response) => {
                EventBus.dispatch(ADMIN_SESSION_REMOVE_SUCCESS)
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}


export default authSlice.reducer;